import { render, staticRenderFns } from "./SurveyMediaQuestions.vue?vue&type=template&id=892d792e&scoped=true&"
import script from "./SurveyMediaQuestions.vue?vue&type=script&lang=js&"
export * from "./SurveyMediaQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SurveyMediaQuestions.vue?vue&type=style&index=0&id=892d792e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892d792e",
  null
  
)

export default component.exports